export enum MangopayDocumentType {
  IdentityProof = 'IDENTITY_PROOF',
  AddressProof = 'ADDRESS_PROOF'
}
